import { render, staticRenderFns } from "./ClassicAttribute.vue?vue&type=template&id=50e0cb6c&scoped=true&"
import script from "./ClassicAttribute.vue?vue&type=script&lang=js&"
export * from "./ClassicAttribute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e0cb6c",
  null
  
)

export default component.exports